/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Step1tag1Inputs */

const zh_landing_workflow_step1tag1 = /** @type {(inputs: Landing_Workflow_Step1tag1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程`)
};

const en_landing_workflow_step1tag1 = /** @type {(inputs: Landing_Workflow_Step1tag1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons`)
};

const es_landing_workflow_step1tag1 = /** @type {(inputs: Landing_Workflow_Step1tag1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones`)
};

/**
* | output |
* | --- |
* | "Lessons" |
*
* @param {Landing_Workflow_Step1tag1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_workflow_step1tag1 = /** @type {((inputs?: Landing_Workflow_Step1tag1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Step1tag1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_step1tag1(inputs)
	if (locale === "en") return en_landing_workflow_step1tag1(inputs)
	return es_landing_workflow_step1tag1(inputs)
});
export { landing_workflow_step1tag1 as "landing_workflow_step1Tag" }